import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";


class ActivityData {
    private _typeData = null;  //类型数据
    private realTypeData = []; //类型数据，根据listItem 得来的真实类型，可能比总类_typeData少；
    private _listData = null;   //list数据；
    private listItem = {};

    private _recommendData = null;
    //public recommendActivityNum = 0;
    //public curRecommendActivityData = null;

    //public recommendTextureArr = [];

    resetData(){
        this._typeData = null;  //类型数据
        this.realTypeData = []; //类型数据，根据listItem 得来的真实类型，可能比总类_typeData少；
        this._listData = null;   //list数据；
        this.listItem = {};

        this._recommendData = null;
        //this.recommendActivityNum = 0;
        //this.curRecommendActivityData = null;
        //this.recommendTextureArr = [];
    }

    async getRealTypeData() {
        if (this.realTypeData.length <= 0){
            if (!this._typeData) {
                this._typeData = await this._getTypeData();
            }
            let typeData = [];
            let listItem = await this.getListItem();
            for (let k = 0;k < this._typeData.length;k++){
                for (let key in listItem){
                    if (this._typeData[k].id.toString() === key){
                        typeData.push(this._typeData[k]);
                        break;
                    }
                }
            }
            this.realTypeData = typeData;
        }
        return this.realTypeData;
    }

    async getListItem() {
        if (JSON.stringify(this.listItem) === "{}"){
            if (!this._listData) {
                this._listData = await this._getListData();
            }
            let rec = this._listData;
            cc.log("====listdata rec:", rec);
            for (let i = 0; i < rec.length; i++) {
                let item = rec[i];
                if (!this.listItem[item.typeId]) {
                    this.listItem[item.typeId] = [];
                }
                this.listItem[item.typeId].push(item);
            }
        }
        return this.listItem;
    }

    async getRecommendActivity() {
        if (!this._recommendData) {
            this._recommendData = await this._getRecommendActivityData();
        }
        return this._recommendData;
    }

    // async getCurRecommendData(){
    //     let recommendData = await this.getRecommendActivity();
    //     if (recommendData && recommendData.length > this.recommendActivityNum){
    //         this.curRecommendActivityData =  recommendData[this.recommendActivityNum];
    //     }
    //     return this.curRecommendActivityData;
    // }


    // async getTextureArr() {//先只保存url
    //     if (this.recommendTextureArr.length <=0){
    //         let recommendData = await this.getRecommendActivity();
    //         for (let i = 0;i < recommendData.length;i++){
    //             let value = recommendData[i].activityImg;
    //             //let texture = await this.loadTexture(value);//
    //             this.recommendTextureArr.push(value);
    //         }
    //     }
    //     return  this.recommendTextureArr;
    // }



    loadTexture(value):Promise<any>{
        return new Promise(resolve => {
            cc.loader.load(value, function (err, texture) {
                if (!err) {
                    resolve(texture);
                } else {
                    resolve(err);
                }
            }.bind(this))
        })
    }


    private _getListData():Promise<any> {
        return new Promise(resolve => {
            NetworkLogic.activityList({},function(rec){
                console.log("====获取ListData：",rec);
                this.listdata = rec;
                resolve(rec);
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                console.log("====获取ListData失败");
                resolve(null);
            }.bind(this))
        })
    }






    private _getRecommendActivityData():Promise<any>{
        return new Promise<any>(resolve => {
            NetworkLogic.activityRecommendActivity({}, function (rec) {
                UIManager.hideLoadingUI()
                cc.log("=====getRecommendActivity rec", rec);
                resolve(rec);
            }.bind(this), function () {
                UIManager.hideLoadingUI()
                cc.log("=====getRecommendActivity err");
                resolve(null);
            }.bind(this))
        })
    }


    private _getTypeData():Promise<any>{
        return new Promise(resolve => {
            NetworkLogic.activityTypeList({},function(rec){
                console.log("====获取typeData：",rec);
                resolve(rec);
            }.bind(this),function () {
                console.log("====获取typeData失败");
                resolve(null);
            }.bind(this))
        })
    }






}

export default new ActivityData()